<template lang="pug">
global-form-group(:title="field.title" :field-name="field.name" :edit-toggle="true")
	div.coordinate-select.slotInput(:class="editable ? '' : 'disable-edit'")
		div
			div.coordinate-line
				input(v-model="lat"
                    step="0.0001"
                    min="0"
                    max="90"
                    @input="changeInput" placeholder="Latitude" type="number")

				select(v-model="lat_label" @change="changeInput")
					option(value="N") N
					option(value="S") S


		div
			div.coordinate-line
				input(v-model="lng"
                    step="0.0001"
                    min="0"
                    max="180"
                    @input="changeInput" placeholder="Longitude" type="number")

				select(v-model="lng_label" @change="changeInput")
					option(value="E") E
					option(value="W") W



		div.desc {{ field.description }}
</template>

<script>
import GlobalFormGroup from "../../GlobalFormGroup";

export default {
	name: "Coordinates",
	components: {GlobalFormGroup},
	props: {
		field: {},
		selected: {},
	},

	data() {
		return {
			lat_tmp: '',
			lng_tmp: '',
			timeout_input: false,
			lat_label: '',
			lng_label: ''
		}
	},

	computed:{
        editable() {
            return this.store.value[`editable_${this.field.name}`];
        },
		lat:{
			get() {
				return Math.abs(this.selected.value.lat)
			},
			set(nv) {
				nv = Math.abs(nv)
				this.lat_tmp = nv > 90 ? 90 : nv;
			}
		},
		lng:{
			get() {
				return Math.abs(this.selected.value.lng)
			},
			set(nv) {
				nv = Math.abs(nv)
				this.lng_tmp = nv > 180 ? 180 : nv;
			}
		}
	},

	updated() {
		this.lng_label = this.selected.value.lng < 0 ? 'W' : 'E';
		this.lat_label = this.selected.value.lat < 0 ? 'S' : 'N';
	},

	mounted() {
		this.lng_tmp = this.selected.value ? Math.abs(this.selected.value.lng) : '';
		this.lat_tmp = this.selected.value ? Math.abs(this.selected.value.lat) : '';

		this.lng_label = this.selected.value.lng < 0 ? 'W' : 'E';
		this.lat_label = this.selected.value.lat < 0 ? 'S' : 'N';
	},

	methods: {
		changeInput() {
			var self = this;

			if (this.timeout_input) {
				clearTimeout(this.timeout_input);
				this.timeout_input = false;
			}

			this.timeout_input = setTimeout(() => {
				self.changeSelect();
			}, 200);
		},

		changeSelect() {
			if (
				this.lat_tmp >= 0 && this.lat_tmp <= 90
				&&
				this.lng_tmp >= 0 && this.lng_tmp <= 180
			) {
				var o = Object.assign({}, this.field);
				o.value.lat = this.lat_tmp * ( this.lat_label === 'N' ? 1 : -1 );
				o.value.lng = this.lng_tmp * ( this.lng_label === 'E' ? 1 : -1 );

				this.$emit('select', o);
			}
		}
	}
}
</script>


<style lang="scss">
.coordinate-select {
	display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 10px;
	> div {

	}
	input {

	}

	.message-valid {
		font-style: italic;
		font-size: 12px;
		color: red;
	}

	.input-secondary {
		margin-left: 10%;
	}

	.switch-checkbox {
		input {
			display: none;
		}

		.text-label {
			font-size: 13px;
			padding: 2px 10px;
			border-radius: 10px;
			background-color: #bfbfbf;
		}
	}

	.coordinate-line {
		display: flex;
		input {
			flex-grow: 1;
            @media (max-width: 991px) {
                background-color: #fff;
            }
		}
		select {
			max-width: 40px;
			min-width: 40px;
			border: none;
			border-bottom: 1px solid black;
			background-color: transparent;
			padding: 6px 0px;
			border-radius: 0;
			font-size: 15px;
			margin-left: 3px;
			width: 100%;
			@media (max-width: 991px) {
				max-width: 80px;
                background-color: #fff;
			}
		}

		.message-valid {
			width: 100%;
		}
	}
}
</style>
